import { render, staticRenderFns } from "./ModalCreatePlatform.vue?vue&type=template&id=66be4d72&scoped=true&"
import script from "./ModalCreatePlatform.vue?vue&type=script&lang=js&"
export * from "./ModalCreatePlatform.vue?vue&type=script&lang=js&"
import style0 from "./ModalCreatePlatform.vue?vue&type=style&index=0&id=66be4d72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66be4d72",
  null
  
)

export default component.exports